<template>
  <div class="lb-screen">
    <div class="page-header">
      <div>
        <div class="page-title">Reyting</div>
        <div class="page-sub">Eng yaxshi o'yinchilar</div>
      </div>
      <div style="font-size:28px">🏆</div>
    </div>

    <!-- Podium top-3 -->
    <div class="lb-podium">
      <!-- 2nd -->
      <div v-if="sorted[1]" class="podium-item p2">
        <div class="podium-avatar">{{ sorted[1].emoji }}</div>
        <div class="podium-name">{{ sorted[1].name }}<span v-if="sorted[1].isMe"> (Sen)</span></div>
        <div class="podium-score">{{ sorted[1].pts }} ball</div>
        <div class="podium-block">2</div>
      </div>
      <!-- 1st -->
      <div v-if="sorted[0]" class="podium-item p1">
        <div class="podium-avatar">
          {{ sorted[0].emoji }}
          <div class="crown">👑</div>
        </div>
        <div class="podium-name">{{ sorted[0].name }}<span v-if="sorted[0].isMe"> (Sen)</span></div>
        <div class="podium-score">{{ sorted[0].pts }} ball</div>
        <div class="podium-block">1</div>
      </div>
      <!-- 3rd -->
      <div v-if="sorted[2]" class="podium-item p3">
        <div class="podium-avatar">{{ sorted[2].emoji }}</div>
        <div class="podium-name">{{ sorted[2].name }}<span v-if="sorted[2].isMe"> (Sen)</span></div>
        <div class="podium-score">{{ sorted[2].pts }} ball</div>
        <div class="podium-block">3</div>
      </div>
    </div>

    <div class="section-title">Barcha o'yinchilar</div>

    <div class="lb-list">
      <div
        v-for="(player, i) in sorted"
        :key="player.name"
        class="lb-item"
        :class="{ me: player.isMe }"
      >
        <div class="lb-rank" :style="{ color: rankColor(i) }">{{ i + 1 }}</div>
        <div class="lb-avatar2">{{ player.emoji }}</div>
        <div class="lb-name">
          {{ player.name }}
          <span v-if="player.isMe" class="lb-me-badge">⭐ Siz</span>
        </div>
        <div class="lb-pts">{{ player.pts }} <span>ball</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from 'vuex';
import { MOCK_LEADERBOARD } from '../../data/questions'

export default {
  name: 'LeaderboardView',

  props: {
    userName: { type: String, default: 'Foydalanuvchi' },
  },

  data() {
    return { store }
  },

  computed: {
    sorted() {
      const me = { name: this.userName, emoji: '🙋', pts: this.$store.totalPts, games: this.$store.totalPlayed, isMe: true }
      return [...MOCK_LEADERBOARD, me].sort((a, b) => b.pts - a.pts)
    },
  },

  methods: {
    rankColor(i) {
      if (i === 0) return 'var(--gold)'
      if (i === 1) return 'var(--silver)'
      if (i === 2) return 'var(--bronze)'
      return 'var(--text3)'
    },
  },
}
</script>
